// extracted by mini-css-extract-plugin
export default {"rootContainer":"App_rootContainer__7yv+t"};